import List from '../../../../components/Main/Product/Lines/List'
import ProductLinesModal from '../../../../components/Main/Product/Lines/ProductLinesModal'
import React, {Fragment} from 'react'

function ProductLines(props) {
  return (
    <Fragment>
      <ProductLinesModal {...props} />
      <List {...props} />
    </Fragment>
  )
}

export default ProductLines
